
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeadStockLineFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeadStockLine"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reference"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"barcode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"latestCostPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"valuationCostPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"costUnitDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"costUnitQuantity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mainSupplierDetails"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstReceiptDate"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"averageUsagePerPeriod"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"averageUsagePercentage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stockLevel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalUsage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deadStock"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"averageUsageTarget"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numberOfPeriods"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"warehouseType"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"outstandingOrderQuantity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unexpiredQuotationQuantity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"quantityOnOrder"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"freeStock"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":762}};
    doc.loc.source = {"body":"fragment DeadStockLineFragment on DeadStockLine {\n  id\n  concurrencyVersion\n  uuid\n  product {\n    id\n    concurrencyVersion\n    uuid\n    reference\n    description\n    barcode\n    latestCostPrice\n    valuationCostPrice\n    costUnitDescription\n    costUnitQuantity\n    mainSupplierDetails {\n      partNumber\n      supplier {\n        reference\n        name\n        email\n      }\n    }\n    firstReceiptDate\n  }\n  averageUsagePerPeriod\n  averageUsagePercentage\n  stockLevel\n  totalUsage\n  deadStock {\n    id\n    concurrencyVersion\n    uuid\n    averageUsageTarget\n    numberOfPeriods\n  }\n  warehouse {\n    id\n    concurrencyVersion\n    uuid\n    description\n    warehouseType\n  }\n  outstandingOrderQuantity\n  unexpiredQuotationQuantity\n  quantityOnOrder\n  freeStock\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["DeadStockLineFragment"] = oneQuery(doc, "DeadStockLineFragment");
        
